export default [
  {
    fullName: 'Nairi Alikhanyan',
    position: 'Chief Executive Officer',
    linkedInAddress: 'https://www.linkedin.com/in/nairi-alikhanyan-37a7a8166/',
    imgSrc: '/assets/images/team/core/Nairi.jpg',
  },
  {
    fullName: 'Tigran Alikhanyan',
    position: 'Head of SAS Department',
    linkedInAddress: 'https://www.linkedin.com/in/tigran-alikhanyan-192ba116a/',
    imgSrc: '/assets/images/team/core/Tigran.jpg',
  },
  {
    fullName: 'Hrach Gevorgyan',
    position: 'Head of Training Center',
    linkedInAddress: 'https://www.linkedin.com/in/hrach-gevorgyan/',
    imgSrc: '/assets/images/team/core/Hrach.jpg',
  },
  {
    fullName: 'Erik Torosyan',
    position: 'Associate Director, Statistical Programming',
    linkedInAddress: 'https://www.linkedin.com/in/erik-torosyan-22449413a/',
    imgSrc: '/assets/images/team/core/Ero.jpg',
  },
  {
    fullName: 'Arman Melkonyan',
    position: 'Associate Director, Statistical Programming',
    linkedInAddress: 'https://www.linkedin.com/in/arman-melkonyan-283449175/',
    imgSrc: '/assets/images/team/core/Arman.jpg',
  },
  {
    fullName: 'Yeghishe Grigoryan',
    position: 'Associate Director, Statistical Programming',
    linkedInAddress: 'https://www.linkedin.com/in/yeghishe-grigoryan-174378192/',
    imgSrc: '/assets/images/team/core/Eghish.jpg',
  },
];
